export interface PayOffInvoicesDto {
  PaymentTypeId: number;
  PaymentDate: Date;
  ApplyDate: Date;
  InvoiceNumbers: Array<number>;
}

export function initializedPayOffInvoicesDto() {
  return {
    PaymentDate: new Date(),
    ApplyDate: new Date(),
    InvoiceNumbers: new Array<number>(),
  } as PayOffInvoicesDto;
}
